import { useTranslation } from 'react-i18next';
import React, {useEffect, useState} from "react";
import axios from 'axios';
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { Grid, Card, Box, TextField,MenuItem,Switch,FormControlLabel,Table, TableContainer,TableHead,TableBody,TableCell,TableRow,Checkbox,Hidden, Button} from '@mui/material'
import { useMessage } from "../../context/message-context";
import {pad} from "../../functions/default";
import { saveAs } from 'file-saver';
import {DataGrid} from '@mui/x-data-grid';
import {API_BASE_URL} from '../../constants/apiConstants';
import { DateTextField, SearchTextField } from "../lib";
function ProjektstundenAuswertung(props) {
  const { t } = useTranslation();
  const {client, accessToken, admin, userid} = props;
  const [isLoading, setIsLoading] = useState(false);
  const {showErrorMessage} = useMessage();
  const [projekt,setProjekt]=useState([]);
  const [mitarbeiter,setMitarbeiter]=useState([]);
  const [maIndex,setMaIndex]=useState(0);
  const [vdat,setVdat]=useState(new Date(new Date().getTime() + 1000*60*60*24*1).getFullYear().toString()+'-'+pad(new Date(new Date().getTime() + 1000*60*60*24*1).getMonth()+1,2)+'-01');
  const [bdat,setBdat]=useState(new Date(new Date().getTime() + 1000*60*60*24*1).getFullYear().toString()+'-'+pad(new Date(new Date().getTime() + 1000*60*60*24*1).getMonth()+1,2)+'-'+pad(new Date(new Date().getTime() + 1000*60*60*24*1).getDate(),2));
  const [summe,setSumme]=useState(false);
  const [tage,setTage]=useState(false);
  const [inaktiv,setInaktiv]=useState(false);
  const [allcheck,setAllcheck]=useState(false);
  const [loaded,setLoaded]=useState(0);
  const [inhalt,setInhalt]=useState([]);
  const [spalten,setSpalten]=useState([]);
  const [columns,setColumns]=useState([]);
  const [rows,setRows]=useState([]);
  const [filter,setFilter]=useState("");
  const [mainaktiv,setMainaktiv]=useState(false);
  useEffect(() => {
    
    setIsLoading(true);
    const payload={
      "mandant": client, // this.props.client,
      "program": (admin==="J")?"PPROJ3":"PPROJN",
      "statement": "AUSWERTUNG",
      "admin":admin,
      "userid":userid,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postUebersicht);
    // eslint-disable-next-line
  }, [])
  const postUebersicht=(response)=>{
    setIsLoading(false);
    console.log(response.status)
    if (response.status === 200) {
      setProjekt(response.data.projekt)
      setMitarbeiter(response.data.mitarbeiter)
      console.log(response.data.mitarbeiter)
    } else {
        if (response) {
            showErrorMessage(response.data.message);
        } else {
            showErrorMessage(t("Keine Internetverbindung"));
        }
    }
  }
  if (isLoading) {
    return <LoadingComponent path={props.location}/>
  }
  function CheckAll(value){
    var tmpliste=[]
    tmpliste=[...projekt];
    tmpliste.forEach((item,index)=>{
      tmpliste[index].checked=value?"1":"0";
    })
    setProjekt(tmpliste);
  }
  function onChange(value,index){
    console.log(value,index)
    var tmpliste=[]
    tmpliste=[...projekt];
    tmpliste[index].checked=value?"1":"0";
    setProjekt(tmpliste);
    setAllcheck(false);
  }
  function Auswerten(){
    setIsLoading(true);
    const payload={
      "mandant": client, // this.props.client,
      "program": (admin==="J")?"PPROJ3":"PPROJN",
      "statement": "START",
      "summe":summe?"1":"0",
      "tage":tage?"1":"0",
      "vdat":vdat,
      "bdat":bdat,
      "user":(mitarbeiter&&mitarbeiter.length>0)&&mitarbeiter[maIndex].id,
      "projekt":projekt,
      "admin":admin,
      "userid":userid,
      "inaktiv":mainaktiv?"1":"0",
      "len":projekt.length.toString(),
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postAuswertung);
  }
  function postAuswertung(response){
    setIsLoading(false);
    if (response.status === 200) {
      setInhalt(response.data.inhalt)
      setSpalten(response.data.spalten)
      console.log(response.data.spalten)
      buildGrid(response.data.inhalt,response.data.spalten)
      setLoaded(1);
    } else {
        if (response) {
            showErrorMessage(response.data.message);
        } else {
            showErrorMessage(t("Keine Internetverbindung"));
        }
    }
  }
  function buildGrid(inh,spa){
    var len=Math.trunc((window.innerWidth-window.innerWidth/10)/(Math.max(spa.length,1)))
    var lenstr=len.toString()+"%"
    
    var tmpliste=[]
    spa.forEach((item,index)=>{
      console.log(lenstr)
      tmpliste.push({field:item.key,headerName:item.name,width:len,})
    })
    setColumns(tmpliste)
    tmpliste=[]
    inh.forEach((item,index)=>{
      tmpliste.push({id:index+1,typ:item.typ,kenn:item.kenn,bez:item.bez,leiter:item.leiter,gruppe:item.gruppe,zusatz:item.zusatz,mitarbeiter:item.mitarbeiter,datum:item.datum,stunden:item.stunden,hproma:item.hproma,summe:item.summe,})
    })
    setRows(tmpliste)
  }
    
  function Excel() {
    downloadFile();
  }
  const downloadFile=()=> {
    const payload={
      "mandant": client, // this.props.client,
      "program": (admin==="J")?"PPROJ3":"PPROJN",
      "statement": "EXCEL",
      "spalten":spalten,
      "inhalt":inhalt,
      "slen":spalten.length,
      "ilen":inhalt.length,
    }
    const headers={
        "Authorization": "Bearer "+accessToken,
        "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
      .then((response) => {
        if (window.cordova) {
          var fileName = 'Auswertung_Projektstunden.xlsx';
          var contentFile = response.data;
          download(fileName, contentFile, 'application/pdf');
        } else {
            const url = window.URL.createObjectURL(response.data);
            const link=document.createElement('a');
            link.href=url
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
      })
      .catch(function (error) {
        console.log(error);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  const download = (filename, data, mimeType) => {
    var blob = new Blob([data], {
      type: mimeType
    });
    if (window.cordova && window.cordova.platformId !== "browser") {
      document.addEventListener("deviceready", function() {
        var storageLocation = "";
        switch (window.cordova.platformId) {
          case "android":
            storageLocation = window.cordova.file.externalDataDirectory;
            break;
          case "ios":
            storageLocation = window.cordova.file.documentsDirectory;
            break;
          default:
            storageLocation = window.cordova.file.externalDataDirectory;
            break;
        }
  
        var folderPath = storageLocation;
  
        window.resolveLocalFileSystemURL(
          folderPath,
          function(dir) {
            dir.getFile(
              filename,
              {
                create: true
              },
              function(file) {
                file.createWriter(
                  function(fileWriter) {
                    fileWriter.write(blob);
  
                    fileWriter.onwriteend = function() {
                      var url = file.toURL();
                      window.cordova.plugins.fileOpener2.open(url, mimeType, {
                        error: function error(err) {
                          console.error(err);
                          alert("Unable to download");
                        },
                        success: function success() {
                          console.log("success with opening the file");
                        }
                      });
                    };
  
                    fileWriter.onerror = function(err) {
                      alert("Unable to download");
                      console.error(err);
                    };
                  },
                  function(err) {
                    // failed
                    alert("Unable to download");
                    console.error(err);
                  }
                );
              },
              function(err) {
                alert("Unable to download");
                console.error(err);
              }
            );
          },
          function(err) {
            alert("Unable to download");
            console.error(err);
          }
        );
      });
    } else {
      saveAs(blob, filename);
    }
  }
  function Projektauswahl(){
    return(
      <TableContainer style={{maxHeight:"500px"}}>
          <Hidden lgDown>
            {ProjektDesktop()}
          </Hidden>
          <Hidden lgUp>
            {ProjektMobil()}
          </Hidden>
      </TableContainer>
    ) 
  }
  function filterFunction (item) {
    if (item.bez1.toLowerCase().includes(filter.toLowerCase())) return(true)
    if (item.bez2.toLowerCase().includes(filter.toLowerCase())) return(true)
    if (item.art.toLowerCase().includes(filter.toLowerCase())) return(true)
    if (item.art.toLowerCase().includes(filter.toLowerCase())) return(true)
    if (item.aktiv.toLowerCase().includes(filter.toLowerCase())) return(true)
    return(false)
  }
  function ProjektDesktop(){
    return(
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
            <Checkbox
              checked={allcheck}
              disabled={filter}
              onChange={(e)=>{setAllcheck(e.target.checked);CheckAll(e.target.checked)}}
              size="small"
            />
            </TableCell>
            <TableCell>{t("Kennung")}</TableCell>
            <TableCell>{t("Bezeichnung")}</TableCell>
            <TableCell>{t("Art")}</TableCell>
            <TableCell>{t("Zusatz")}</TableCell>
            <TableCell>{t("Status")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projekt&&projekt.length>0&&projekt.filter(filterFunction).map((item,index)=>{
          if (item.aktiv==="inaktiv"&&inaktiv===false) return(
            <Hidden xsUp>
            <TableRow key={index.toString()}>
              <TableCell ></TableCell>
            </TableRow>
            </Hidden>
          );
          return(
            <TableRow>
              <TableCell>
                <Checkbox
                checked={item.checked==="1"}
                onChange={(e)=>onChange(e.target.checked,item.ind)}
                size="small"
                />
              </TableCell>
              <TableCell>{item.bez1}</TableCell>
              <TableCell>{item.bez2}</TableCell>
              <TableCell>{item.art}</TableCell>
              <TableCell>{item.leiter}</TableCell>
              <TableCell>{item.aktiv}</TableCell>
            </TableRow>
          )
          })}   
        </TableBody>
      </Table>
    )
  }
  function ProjektMobil(){
    return(
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
            <Checkbox
              checked={allcheck}
              disabled={filter}
              onChange={(e)=>{setAllcheck(e.target.checked);CheckAll(e.target.checked)}}
              size="small"
            />
            </TableCell>
            <TableCell>{t("Info")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {projekt&&projekt.length>0&&projekt.filter(filterFunction).map((item,index)=>{
          if (item.aktiv==="inaktiv"&&inaktiv===false) return(
            <Hidden xsUp>
            <TableRow key={index.toString()}>
              <TableCell ></TableCell>
            </TableRow>
            </Hidden>
          );
          return(
            <TableRow>
              <TableCell>
                <Checkbox
                checked={item.checked==="1"}
                onChange={(e)=>onChange(e.target.checked,item.ind)}
                size="small"
                />
              </TableCell>
              <TableCell>
                {item.art+": "+item.bez1+" ("+item.aktiv+")"}<br/>{item.bez2}<br/>{item.leiter}
              </TableCell>
            </TableRow>
          )
        })}
        </TableBody>
      </Table>
    )    
  }
    return (    
        <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} md={8}>
                <Card>
                    <Box p={2}>
                        <Grid justifyContent="center" container spacing={2}>
                        <Grid item xs={12}>
                        <h4>{t("Allgemeine Einstellungen")}</h4>
                        </Grid>
                            
                            <Grid item xs={12} md={4}>
                                <TextField
                                  fullWidth
                                  variant="outlined"
                                  label={t("Mitarbeiter")}
                                  select
                                  value={maIndex}
                                  onChange={event=>setMaIndex(event.target.value)}
                                >
                                  {mitarbeiter&&mitarbeiter.length>0&&mitarbeiter.map((item,index)=>{
                                    if (item.inaktiv==="J" && mainaktiv===false) return
                                    return(
                                    <MenuItem key={index} value={index}>{item.name}</MenuItem>
                                    )
                                  })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <DateTextField
                                fullWidth
                                variant="outlined"
                                label={t("Datum Von")}
                                value={vdat}
                                onChange={event=>setVdat(event.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <DateTextField
                                fullWidth
                                variant="outlined"
                                label={t("Datum Bis")}
                                value={bdat}
                                onChange={event=>setBdat(event.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                            <FormControlLabel
                              control={
                                <Switch
                                checked={mainaktiv}
                                onChange={event=>setMainaktiv(event.target.checked)}
                                name="Summe"
                                color="primary"
                                inputProps={{'aria-label': 'secondary checkbox'}}
                                />
                              }
                              label='Inaktive Mitarbeiter anzeigen (letzte 12 Monate)'
                            />
                            </Grid>
                            <Grid item xs={12} md={4}>
                            <FormControlLabel
                              control={
                                <Switch
                                checked={summe}
                                onChange={event=>setSumme(event.target.checked)}
                                name="Summe"
                                color="primary"
                                inputProps={{'aria-label': 'secondary checkbox'}}
                                />
                              }
                              label='"Summe aller Mitarbeiter pro Projekt" einblenden'
                            />
                            </Grid>
                            <Grid item xs={12} md={4}>
                            <FormControlLabel
                              control={
                                <Switch
                                checked={tage}
                                onChange={event=>setTage(event.target.checked)}
                                name="Tage"
                                color="primary"
                                inputProps={{'aria-label': 'secondary checkbox'}}
                                />
                              }
                              label='Auswertung nach Tagen'
                            />
                            </Grid>
                        </Grid>
                    </Box>
                </Card>
            </Grid>
            <Grid item xs={12} md={8}>
              <Card>
                <Box p={2}>
                  <Grid container justifyContent="center" spacing={2}>
                      <Grid item xs={12}>
                        <h4>{t("Projekteinstellungen")}</h4>
                        </Grid>
                    <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={inaktiv}
                          onChange={event=>setInaktiv(event.target.checked)}
                          name="Inaktiv"
                          color="primary"
                          inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                      }
                      label='Inaktive Projekte in Auswahl anzeigen'
                      />
                    </Grid>
                    <Grid item xs={12} sm={8} md={6} lg={4}>
                     <Box p={2}>
                       <SearchTextField
                            size="small"
                            fullWidth
                            label={t("Suche")}
                            id="filter2"
                            variant="outlined"
                            value={filter}
                            inputProps={{
                            autoCapitalize: 'off',
                            autoCorrect: 'off',
                            spellCheck: 'false',
                            autoComplete: 'off'
                            }}
                            onChange={(e)=>setFilter(e.target.value)}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      {Projektauswahl()}
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            </Grid>
            <Grid item xs={12} md={8}>
                  <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={()=>Auswerten()}
                      >
                        {t("Projekte auswerten")}
                      </Button>
                    </Grid>
                  </Grid>
            </Grid>
            {loaded===1&&
            <Grid item xs={12} >
              <Card>
                <Box p={2}>
                  <Grid container justifyContent="center" spacing={2}>
                  <Grid item xs={12}>
                        <h4>{t("Ergebnisse")}</h4>
                        </Grid>
                    <Grid item xs={12}>
                      <div style={{height:500,width:"100%"}} >
                        <DataGrid rows={rows} columns={columns} pageSize={10}/>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={Excel}
                      >
                        {t("In Excel")}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            </Grid>
            }
        </Grid>
    );
  }
export default ProjektstundenAuswertung;
